var gdosWrapper = {
	config: {
		postal: "//api.opencagedata.com/geocode/v1/json",
		search: "//public.api.gdos.salvationarmy.org/search",
		zip: undefined,
		latLong: [],
		gdosResults: [],
		groupedResults: [],
		servicesByLocation: [],
		locationByService: [],
		icon: '//static.salvationarmy.org/us-east-1/templates/symphony/static_resources/images/global/location-pin.svg',
		resultsContainer: $('.gdosResults')
	},
	getLatLong: function (postalCode) {
		var getData = {
			q: postalCode,
			limit: 50,
			key: openCageApiKey
		};
		if (typeof siteCountry != "undefined") {
			getData = {
				q: postalCode,
				limit: 50,
				countrycode: siteCountry.toLowerCase(),
				key: openCageApiKey
			}
		}
		return $.get(gdosWrapper.config.postal, getData).then(function (data) {
			var d = {
				latitude: thqLatitude,
				longitude: thqLongitude
			};
			if (data.results.length > 0) {
				data.results = $.grep(data.results, function (x) {
					return typeof x.components != "undefined" && 
					typeof x.components.country != "undefined" && 
					typeof x.components.country_code != "undefined" && 
					(x.components.country_code.toLowerCase() == "us" || x.components.country.toLowerCase() == "usa") &&
					typeof data.results[0].geometry != "undefined" && 
					typeof data.results[0].geometry.lat != "undefined" && 
					typeof data.results[0].geometry.lng != "undefined";
				});
				if (data.results.length > 0) {
					var postcodeMatches = $.grep(data.results, function(result) {
						return typeof result.components != "undefiend" && typeof result.components.postcode != "undefiend" && result.components.postcode == postalCode;
					});
					if (postcodeMatches.length > 0) {
						var loc = postcodeMatches[0].geometry;
						d.latitude = loc.lat;
						d.longitude = loc.lng;
					} else {
						var loc = data.results[0].geometry;
						d.latitude = loc.lat;
						d.longitude = loc.lng;
					}
				}
			}
			return d;
		});
	},

	getCenters: function (lat, long, cat) {
		return $.get(gdosWrapper.config.search, {
			isoCountry: 'us',
			lat: lat,
			lng: long,
			distanceUnits: 'MILES',
			limit: 20,
			categories: cat
		}).then(function (data) {
			return data;
		});
	},
	parseResults: function (data) {

		if (!gdosWrapper.validateData(data)) {
			return;
		}

		var parsedResults = data;

		if (typeof data === "string") {
			parsedResults = JSON.parse(data);
		}

		return parsedResults;

	},
	groupResults: function (data, mappings) {
		var goodToGo = gdosWrapper.validateData(data);

		if (goodToGo) {
			if (mappings.length > 0) {
				var $cats = $('<div></div>');
				$cats.append('<p>To narrow down your search results, please select a category below:</p>');
				var $ul = $('<ul></ul>');
	
				var idx = window.location.href.indexOf("?");
				var baseUrl = idx < 0 ? window.location.href : window.location.href.replace(window.location.href.substr(idx), "");
				var baseUrlPlus = "";
				var cat = symphony.getURLParam('map');
	
				var kvPairs = $.grep(symphony.queryStringToKeyValue(), function (x) {
					return x.key != "map";
				});
				if (kvPairs.length > 0) {
					baseUrl = baseUrl + symphony.keyValueToQueryString(kvPairs);
					baseUrlPlus = baseUrl + "&";
				} else {
					baseUrlPlus = baseUrl + "?";
				}
	
				$.each(mappings, function (i, m) {
					var selected = typeof cat != "undefined" && Number(cat) == Number(m.id);
					$ul.append('<li>\
						' + (selected ? '<a href="' + baseUrl + '" class="close"><i class="fa fa-times"></i></a>' : '') + '\
						<a href="' + baseUrlPlus + 'map=' + m.id + '" ' + (selected ? 'style="font-weight:bold"' : '') + '>' + m.title + '</a>\
					</li>');
				});
				var $div = $('<div class="gdosResults-serviceList"></div>');
				$div.append($ul);
				$cats.append($div);
	
				$('.gdosResults-categories').show();
				$('.gdosResults-categories').html($cats.html());
			} else {
				$('.gdosResults-categories').empty().hide();
			}
		}

		return data;
	},
	storeResults: function (data) {

		if (!gdosWrapper.validateData(data)) {
			return;
		}

		if (!window.localStorage) {
			return;
		}

		localStorage.setItem("gdosResults", data);

		if (window.utag_data !== 'undefined') {
			window.utag_data.location_results = JSON.parse(data);
		}

	},
	validateData: function (data) {
		if (data === null || data === undefined || typeof data == 'undefined') {
			return false;
		}
		return true;
	},
	createMap: function (data, element) {

		if (!gdosWrapper.validateData(data) || !gdosWrapper.validateData(element)) {
			return;
		}

		if (data.length == 0 || typeof data[0] == "undefined" || typeof data[0].location == "undefined") {
			$('.gdosController-map').html("<p><b>Sorry, the search returned no locations. Please try again.</b></p>")
			return;
		}

		var map = new GMaps({
			el: element,
			lat: data[0].location.latitude,
			lng: data[0].location.longitude,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			disableDefaultUI: true,
			draggable: false
		});

		_(data).forEach(function (center) {
			map.addMarker({
				lat: center.location.latitude,
				lng: center.location.longitude,
				title: center.name,
				click: function (e) {
					var context = this;
					_(map.markers).forEach(function (marker) {
						marker.setIcon(context.icon);
					});
					e.setIcon(context.activeIcon);
					$('.gdosDetails').removeClass('isActive').empty().append(symphony.templates.gdosSingleResult(center)).addClass('isActive');
				},
				icon: {
					size: new google.maps.Size(24, 39),
					url: gdosWrapper.config.icon
				},
				activeIcon: {
					size: new google.maps.Size(24, 39),
					icon: '//static.salvationarmy.org/us-east-1/templates/symphony/static_resources/images/global/location-pin.svg'
				}
			});
		});
		map.refresh();
		map.fitZoom();
	}
};
